import { render, staticRenderFns } from "./SaleInvoiceTypeCreationModal.vue?vue&type=template&id=4c063778&scoped=true&"
import script from "./SaleInvoiceTypeCreationModal.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceTypeCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c063778",
  null
  
)

export default component.exports